import { createI18n } from "vue-i18n"
import { DefaultI18nOptions } from "@versatile-credit-apply/sdk"

import messages from "@intlify/unplugin-vue-i18n/messages"

export const i18n = createI18n({
  ...DefaultI18nOptions,
  messages,
})
